import React, { Component } from 'react'
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import Responsive from '../../components/Responsive';
import { addToCard, checkTranslation, conditionalWidth, translate } from '../../utils/useful';
import StagesManager from '../../components/StagesManager';
import FormViewer from '../../components/FormViewer';
import HttpServices from '../../utils/Http.services';
import SwitchInput from '../../components/inputs/SwitchInput';
import HelpButton from '../../components/HelpButton';
import CommerceCart from './CommerceCart';
import { duration } from 'jalali-moment';
import SubscriptionPage from './SubscriptionPage';

export default class UpgradeAccount extends Component {
    state = {
        display: true,
        data: {},

    }

    componentDidMount() {


    }


    fetchPriceData = () => {

        let body = {
            applet: '66437fe0866feba9035be16e',
            appletHub: '66437a69866feba9035bdd5f'
        }
        HttpServices.request('getProducts', body, (fetchResult, fetchError) => {

            // console.log(fetchResult)
            if (fetchError) {
                return
            }

            let currentPlan = this.state.currentPlan
            let currentLevel
            let pricingData = fetchResult.info
            let prices = {}
            let priceDurations = []
            let pricingConfig = {}
            let currentDuration
            let sort = ['Starter', 'Team', 'Professional', 'Enterprise']
            let showSaving = true

            pricingData.sort((a, b) => sort.indexOf(a.name) - sort.indexOf(b.name));



            pricingData.forEach((element, index) => {

                if (element.name == currentPlan) {
                    currentLevel = index
                }



                if (element.priceType == 'subscription') {
                    if (Array.isArray(element.subscriptionPrice)) {

                        prices[element._id] = {}


                        element.subscriptionPrice.forEach(sprice => {


                            prices[element._id][(sprice.repeat ?? '1') + "-" + sprice.duration] = { price: sprice.price, duration: sprice.duration, repeat: sprice.repeat }

                            let found = false
                            priceDurations.forEach(pduration => {
                                if (pduration.duration == sprice.duration && pduration.repeat == sprice.repeat) {
                                    found = true
                                }
                            });

                            if (!found) {
                                let label = sprice.duration
                                if ((sprice.repeat ?? 1) == 1) {
                                    if (sprice.duration == 'year') {
                                        label = '{{lang}}Yearly'
                                    }
                                    if (sprice.duration == 'month') {
                                        label = '{{lang}}Monthly'
                                    }
                                    if (sprice.duration == 'week') {
                                        label = '{{lang}}Weekly'
                                    }
                                } else {
                                    label = `${sprice.repeat} ${sprice.duration}s`
                                }

                                priceDurations.push({ duration: sprice.duration, repeat: sprice.repeat, key: (sprice.repeat ?? '1') + "-" + sprice.duration, label })

                            }

                        })
                    }
                }

            })

            if (priceDurations.length > 0) {
                let samePricing = true

                priceDurations.forEach(pDuration => {

                    if (!currentDuration) {
                        currentDuration = pDuration
                    } else {

                        if (currentDuration.duration == 'week' && ((pDuration.duration == 'month' || pDuration.duration == 'year') || (pDuration.duration == 'week' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
                            currentDuration = pDuration
                        }

                        if (currentDuration.duration == 'month' && ((pDuration.duration == 'year') || (pDuration.duration == 'month' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
                            currentDuration = pDuration
                        }

                        if (currentDuration.duration == 'year' && ((pDuration.duration == 'year' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
                            currentDuration = pDuration
                        }

                    }

                    if (currentDuration.duration == 'year') {
                        showSaving = true
                    }

                    pricingData.forEach(element => {

                        if (element.priceType == 'subscrition') {
                            let found = false
                            element.subscriptionPrice.forEach(sprice => {
                                if (pDuration.duration == sprice.duration && pDuration.repeat == sprice.repeat) {
                                    found = true
                                }
                            })

                            if (!found) {
                                samePricing = false
                            }
                        }
                    })

                })

                pricingConfig.samePricing = samePricing
            }

            if (priceDurations.length == 2) {

                pricingConfig.showSwitch = true

            }

            if (priceDurations.length > 1 && showSaving) {
                pricingConfig.showSaving = true
            }


            let durationSort = ['week', 'moth', 'year']

            priceDurations.sort((a, b) => durationSort.indexOf(a.duration) - durationSort.indexOf(b.duration) || (a.repeat ?? 1) - (b.repeat ?? 1));



            // console.log(priceDurations)
            // console.log(pricingConfig)
            // console.log(prices)

            this.setState({ pricingData, pricesInfo: prices, priceDurations, pricingConfig, currentLevel, currentDuration })



        })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.checkOut}
                    isLoading={this.state.isLoading}
                    title={translate("{{lang}}Check Out")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }
    checkOut = () => {
        // console.log('this.props.data', this.props)
        let data = this.priceForm.getForm()
        let billing = this.form.getForm()
        if (data && billing) {
            // console.log('firstdata', data)
            // let body = { quantity: data?.quantity, serviceType: data?.serviceType, subscription: data?.subscription, expiry: { value: data?.service, unit: 'year' } }
            let body = { ...{ serviceInfo: data }, ...billing }
            HttpServices.request('checkoutWithStripe', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                // console.log('fetchResult', fetchResult.info.url)
                window.location.href = fetchResult.info.url
            })
        }
    }
    nextClicked = (status, serviceType) => {
        // console.log('nextClicked', serviceType)
        let data = this.state.data
        data.serviceType = serviceType
        console.log(data)
        this.setState({ data, status }, () => {
            this.stageManager.changeStage("pricingInfo")
        })

    }

    changeType = (prop, index) => {
        this.props.setData({ category: prop.name }, () => {
        })
    }

    toggleDisplay = () => {
        this.setState(prevState => ({
            display: !prevState.display
        }))
    }

    afterSet = (item) => {
        this.addToCart('add', 1, item, () => {
            this.props.changePage(['account', 'payment'])
        })
    }

    addToCart = (action, count, item, cb) => {

        if (!this.state.isLoading) {
            let applet = this.props.applet
            let hub = this.props.variables?.targetHub

            let variants = item?.variants
            let additionals = item?.additionals
            let product = item?._id
            this.setState({ isLoading: true })
            console.log('addToCart1', applet)
            console.log('addToCart2', this.props.variables,hub)
            console.log('addToCart3', variants)
            console.log('addToCart4', additionals)
            console.log('addToCart5', product)
            // console.log('addToCart6', item)
            // return
            addToCard(applet, hub, product, action, count, variants, additionals, () => {
                this.setState({ isLoading: false }, () => {
                    if (cb) {
                        cb()
                    }
                })
            })
        }
    }

    setData = (data, cb) => {
        cb()
    }

    render() {

        return (
            <div className=" w-100 h-100  position-relative window-content-radius scroll-no-scrollbar" style={{}}>
                <SubscriptionPage width={this.props.width} variables={this.props.variables} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} height={this.props.height} type={'update'} setData={this.setData} afterSet={this.afterSet} />
            </div>
        )
    }
}
